import React, { useState, useEffect, useMemo } from "react";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  OutlinedInput,
  IconButton,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Stack,
  Box,
  useTheme,
  Tooltip,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";

import { getMachineDepartments, deleteMachineLocation } from "features/service/service.slice";
import { Links } from "utils/pageLinkNames";
import Header from "component/Header";
import DataGridTable from "component/DataGridTable";
import TableSkeleton from "component/Loaders/TableSkeleton";

const Locations = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const { mode } = useSelector((state) => state.globalState);
  const [selectedLocation, setSelectedLocation] = useState(null);

  useEffect(() => {
    dispatch(getMachineDepartments());
  }, [dispatch]);

  const gridLocationAction = (args) => {
    return (
      <div>
        <IconButton sx={{ mr: 1 }} onClick={() => navigate(`/${Links.EDIT_LOCATION}/` + args.row.id)}>
          <Tooltip title="Edit">
            <EditIcon sx={{ color: mode === "dark" ? "#fff" : theme.palette.primary[50] }} />
          </Tooltip>
        </IconButton>
        {/* <IconButton
          sx={{ mr: 1 }}
          onClick={() => {
            setSelectedLocation(args.row);
            setShowDialog(true);
          }}
        >
          <Tooltip title="Delete">
            <DeleteIcon sx={{ color: mode === "dark" ? "#fff" : theme.palette.primary[50] }} />
          </Tooltip>
        </IconButton> */}
      </div>
    );
  };

  const tableGrids = [
    {
      field: "name",
      headerName: "Location",
      minWidth: 200,
      flex: 0.2,
    },
    {
      field: "description",
      headerName: "Description",
      minWidth: 500,
      flex: 0.4,
    },
    {
      minWidth: 100,
      flex: 0.1,
      sortable: false,
      filterable: false,
      renderCell: gridLocationAction,
    },
  ];

  const [showDialog, setShowDialog] = useState(false);

  const { isLoading, machineDepartments } = useSelector((state) => state.service);

  const [searchValue, setSearchValue] = useState("");

  const visibleLocations = useMemo(() => {
    const q = searchValue.toLowerCase();
    return [...(machineDepartments || [])]
      .filter((item) => Object.values(item).join(" ").toLowerCase().includes(q))
      .sort((a, b) => (a?.name || "").localeCompare(b?.name || "", undefined, { sensitivity: "base" }));
  }, [machineDepartments, searchValue]);

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  // const onConfirmDelete = async () => {
  //   dispatch(deleteMachineLocation(selectedLocation.id)).then((deleteRes) => {
  //     if (deleteRes && deleteRes.error) return toast.error("Something went wrong!");
  //     if (deleteRes && deleteRes.payload && deleteRes.payload.status === 200) {
  //       dispatch(getMachineDepartments()).then((res) => {
  //         toast.success(deleteRes?.payload?.data?.message || "", {
  //           autoClose: 1500,
  //         });
  //         setShowDialog(false);
  //       });
  //     } else return toast.error("Something went wrong!");
  //   });
  // };

  return (
    <div>
      <Stack sx={{ ml: 2, mt: 2, mb: 1 }}>
        <Header titles={["Locations"]} />
      </Stack>
      <Box sx={{ mx: 2 }}>
        {/* <div>
          <Dialog open={showDialog} onClose={() => setShowDialog(false)}>
            <DialogTitle>
              <Typography sx={{ fontWeight: "bold" }}>Confirm Delete</Typography>
            </DialogTitle>
            <DialogContent>
              <Typography mt={1}>
                Confirm to delete location <span style={{ fontWeight: "bold" }}>{`${selectedLocation?.name || ""}`}</span>?
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setShowDialog(false)}>Cancel</Button>
              <Button sx={{}} onClick={onConfirmDelete}>
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
        </div> */}
        <Stack direction={"row"} gap={1} alignItems={"center"} my={2}>
          <Box>
            <Button
              startIcon={<AddIcon />}
              sx={{ height: "self" }}
              autoCapitalize="none"
              variant="contained"
              onClick={() => navigate(`/${Links.ADD_LOCATION}/`)}
            >
              Add
            </Button>
          </Box>
          <OutlinedInput
            id="outlined-adornment-password"
            value={searchValue}
            onChange={(event) => handleSearchChange(event)}
            placeholder="Search..."
            endAdornment={
              <InputAdornment position="end">
                <IconButton aria-label="toggle password visibility" edge="end">
                  <Search />
                </IconButton>
              </InputAdornment>
            }
            sx={{ minWidth: 300, maxWidth: 600, height: 35 }}
          />
        </Stack>
        {isLoading ? (
          <TableSkeleton rows={8} columns={tableGrids.length} />
        ) : (
          <DataGridTable
            checkboxSelection={false}
            rowId={"id"}
            data={visibleLocations}
            columnAttributes={tableGrids}
          />
        )}
      </Box>
    </div>
  );
};
export default Locations;
